import { IUser } from '../../models/IUser';
import api from '../api'

export const createUser = async (user: IUser) => {
    const { data } = await api.post('profile/', user);

    return data
}

export const createFavoriteBulk = async (favoriteMaterials: any) => {
    const { data } = await api.post('products/favorite/bulk/', favoriteMaterials);

    return data
}

export const sendActivationCode = async (email: string, name: string) => {
    let params = {
      email: email,
      name: name
    }

    const { data } = await api.post('create_key/', params);

    return data
}

export const verifyActivationCode = async (code: string, email: string) => {
    let params = { key: code, email: email}

    const { data } = await api.post('check_activation/', params);

    return data
}